<template>
  <v-layout row>
    <v-flex xs12>
      <div class="seller-list pa-4">
        <v-list
          v-if="storeSellers && storeSellers.length != 0"
          subheader
        >
          <v-list-tile
            v-for="item in storeSellers"
            :key="item.id"
            avatar
            :to="`/sellers/${item.id}`"
          >
            <v-list-tile-avatar
              :color="item.disabled ? '#F1EFEC' : '#ECF6AA'"
            >
              <span> {{ initials(item.name) }}
              </span>
            </v-list-tile-avatar>

            <v-list-tile-content class="client-name">
              {{ item.name }}
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn
                fab
                flat
                small
                color="#099AB1"
              >
                <v-icon
                  small
                  color="primary"
                >
                  $vuetify.icons.arrowRightIcon
                </v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <Loader v-else />
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { computed, defineComponent } from '@vue/composition-api';
import { uniqBy, orderBy } from 'lodash';
import { useVuexSellerStores } from '../../composables/useVuexSellerStores';
import { useManagerDashboard } from '../../composables/useManagerDashboard';

export default defineComponent({
  components: {
  },
  setup(props, { root }) {
    const customer = computed(() => root.$store.state.customer);
    const { stores: sellerStores, loading: loadingStores } = useVuexSellerStores(root);
    const {
      storeSelected,
    } = useManagerDashboard();
    const storeSellers = computed(() => {
      if (storeSelected.value && storeSelected.value.name === 'Todas as Lojas') {
        const storeSellersReduced = sellerStores.value.reduce((a, b) => a.concat(b.sellers), []);
        return orderBy(uniqBy(storeSellersReduced, 'id'), [(seller) => !!seller.disabled, (seller) => seller.name.toLowerCase()], ['asc', 'asc']);
      }
      return orderBy(storeSelected.value.sellers, [(seller) => !!seller.disabled, (seller) => seller.name.toLowerCase()], ['asc', 'asc']);
    });
    function initials(name) {
      return name.match(/(\b\S)?/g).join('').match(/(^\S|\S$)?/g).join('')
        .toUpperCase();
    }
    return {
      customer,
      initials,
      storeSellers,
      sellerStores,
      storeSelected,
      loadingStores,
    };
  },
});
</script>

<style lang="scss" scoped>
  .seller-list {
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    border-radius: 7px;
  }
  .v-list__tile {
    padding-right: 0px;
    padding-left: 8px;
    border-bottom: 0.829458px solid #8A8691;
  }
  .avatarImg {
    max-width: 40px;
    max-height: 40px;
  }
  .client-name {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }

</style>
